import React, { useContext, useState } from 'react';
import { ContentMisPacientes } from '../../components/MisPacientes/ContentMisPacientes';
import { MiFooter } from "../../components/footer/MiFooter";
import { UsuarioContext } from '../../contexts/UsuarioContext';
import './MisPacientes.css';
import HeaderHome from '../../components/headerHome/HeaderHome';


export const MisPacientes = () => {

  /* A hook that is used to change the state of the menu. */
  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }
  return (
    <div className="MisPacientes">
      <div className="headerMisPacientes">
        <HeaderHome 
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyMisPacientes">
        <ContentMisPacientes 
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="footerMisPacientes">
        <MiFooter />
      </div>
    </div>
  )
}